// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"294c232a","732":"3c345511","977":"37db1feb"}[chunkId] + ".chunk.js";
};